import { Dialog, DialogContent, TextField } from "@mui/material"
import { BoxFC, BoxFR } from "components/BoxCustom"
import PaperComponent from "components/PaperComponent"
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import ComboBox from "components/ComboBox"
import AddButton from "components/buttons/AddButton"
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand"
import { RemoveCircleRounded } from "resource/muiImport"
import { GridActionsCellItem } from "@mui/x-data-grid-pro"
import { cusColNm } from "constants/cusConstant"
import React, { useCallback, useContext, useEffect, useState } from "react"

const initFilterData = { CusId: null, StkCod: null }
const initAddData = { CusId: null, StkCod: "" }

const CusAdvDialog = ({ dialogOpen, setDialogOpen }) => {
  const { ax, msData } = useContext(GlobalStateContext)
  const [dataTable, setDataTable] = useState([])
  const [addData, setAddData] = useState({ ...initAddData })

  const setTable = useCallback((data) => {
    setDataTable(data.map((row, index) => ({ ...row, id: index + 1, No: index + 1 })))
  }, [])

  const getData = useCallback((filter) => {
    ax.post("/branch/c-smile/getCusStkCod", filter).then(value => {
      if (value.data) setTable(value.data)
    })
  }, [ax, setTable])

  const handleAdd = useCallback(() => {
    ax.post("/branch/c-smile/insertCusStkCod", addData).then(value => {
      if (value.data) {
        setTable(value.data)
        setAddData({ ...initAddData })
      }
    })
  }, [ax, addData, setTable])

  const handleDelete = useCallback((row) => {
    ax.post("/branch/c-smile/deleteCusStkCod", { CusId: row.CusId, StkCod: row.StkCod }).then(value => {
      if (value.data) setTable(value.data)
    })
  }, [ax, setTable])

  const columns = [
    { field: "No", headerName: "No.", width: 50, align: "center" },
    { field: "SName", headerName: cusColNm.SName, width: 200 },
    { field: "StkCod", headerName: "รหัสสินค้า", flex: 1 },
    {
      field: "actions",
      type: "actions",
      width: 40,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<RemoveCircleRounded color="error" />}
          label="Delete"
          onClick={() => handleDelete(params.row)}
        />
      ]
    },
  ]

  const handleStkCodKeyUp = useCallback((e) => {
    if (e.key === "Enter") handleAdd()
  }, [handleAdd])
  useEffect(() => {
    if (dialogOpen) {
      getData(initFilterData)
    }
  }, [dialogOpen, getData])

  return (
    <Dialog open={dialogOpen} PaperComponent={PaperComponent} aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth="sm">
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="กำหนดรหัสสินค้าตามลูกค้า"
        onDeleteClick={null}
      />
      <DialogContent>
        <BoxFC pt={2} gap={2}>
          <BoxFR>
            <ComboBox sx={{ width: 200 }} options={msData.cusCombo} label={cusColNm.SName}
              selectedId={addData.CusId}
              setSelectedId={(id) => setAddData(o => ({ ...o, CusId: id }))}
            />
            <TextField size="small" label="รหัสสินค้า" sx={{ width: 150 }}
              value={addData.StkCod}
              onChange={(e) => setAddData(o => ({ ...o, StkCod: e.target.value }))}
              onKeyUp={(e) => handleStkCodKeyUp(e)}
            />
            <AddButton onClick={handleAdd} />
          </BoxFR>
          {/* <BoxFR>
            <ComboBox sx={{ width: 200 }} options={msData.cusCombo} label={`ค้นหา ${cusColNm.SName}`}
              selectedId={filterData.CusId}
              setSelectedId={(id) => setFilterData(o => ({ ...o, CusId: id }))}
            />
            <TextField size="small" label="ค้นหา StkCod" sx={{ width: 150 }}
              value={filterData.StkCod ?? ""}
              onChange={(e) => setFilterData(o => ({ ...o, StkCod: e.target.value || null }))}
              onKeyUp={(e) => { if (e.key === "Enter") getData(filterData) }}
            />
            <SearchButton onClick={() => getData(filterData)} />
            <ClearButton onClick={() => { setFilterData({ ...initFilterData }); getData(initFilterData) }} />
          </BoxFR> */}
          <DataGridCellExpand
            hideFooter
            autoHeight
            rows={dataTable}
            columns={columns}
          />
        </BoxFC>
      </DialogContent>
      <DialogFooter okText={null}
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={null}
      />
    </Dialog>
  )
}

export default React.memo(CusAdvDialog)
